import get from 'lodash/get';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import toArray from 'lodash/toArray';

import validateBehaviorNodes from './validateBehaviorNodes';
import validateControlTypes from './validateControlTypes';
import validateEmptyChecks from './validateEmptyChecks';
import validateEndConditions from './validateEndConditions';
import validateMedicationNodes from './validateMedicationNodes';
import validateInfusionNodes from './validateInfusionNodes';
import validateOxygenActions from './validateOxygenActions';
import validateOxygenChecks from './validateOxygenChecks';
import validateIVChecks from './validateIVChecks';
import validateInterventionNodes from './validateInterventionNodes';
import validateMigratedNodes from './validateMigratedNodes';
import validateMonitorNodes from './validateMonitorNodes';
import validateNodeConnections from './validateNodeConnections';
import validateLabMediaNodes from './validateLabMediaNodes';
import validateMoulageNodes from './validateMoulageNodes';
import validateProcedureControls from './validateProcedureControls';
import validateDialogueControls from './validateDialogueControls';
import validateTransferScene from './validateTransferScene';
import validateCustomStateNodes from './validateCustomStateNodes';
import validateGradeEffectNodes from './validateGradeEffectNodes';
import validateExposeNodes from './validateExposeNodes';
import validateCheckCounts from './validateCheckCounts';
import validatePulseStrengthChecks from './validatePulseStrengthChecks';
import validateGradingConflicts from './validateGradingConflicts';
import validateTriggeringActions from './validateTriggeringActions';
import validateCustomMenuNodes from './validateCustomMenuNodes';

function validateCaseLogicDescription(
  caseConf,
  validationOptions = { isEffectChain: false, isMedicationEffectChain: false }
) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes')) || [];
  const nodeInfo = {
    actionNodes: nodes.filter(node => node.name === 'Action'),
    checkNodes: nodes.filter(node => node.name === 'Check'),
    effectNodes: nodes.filter(node => node.name === 'Effect'),
    effectChainNodes: nodes.filter(node => node.name === 'EffectChain'),
  };
  const validationResults = [
    validateBehaviorNodes(caseConf, nodeInfo, validationOptions),
    validateControlTypes(caseConf, validationOptions),
    validateEmptyChecks(caseConf, validationOptions),
    validateEndConditions(caseConf, validationOptions),
    validateMedicationNodes(caseConf, validationOptions),
    validateInfusionNodes(caseConf, nodeInfo, validationOptions),
    validateOxygenActions(caseConf, validationOptions),
    validateOxygenChecks(caseConf, validationOptions),
    validateIVChecks(caseConf, validationOptions),
    validateInterventionNodes(caseConf, validationOptions),
    validateMigratedNodes(caseConf, validationOptions),
    validateMonitorNodes(caseConf, validationOptions),
    validateMoulageNodes(caseConf, validationOptions),
    validateNodeConnections(caseConf, validationOptions),
    validateLabMediaNodes(caseConf, validationOptions),
    validateProcedureControls(caseConf, validationOptions),
    validateDialogueControls(caseConf, validationOptions),
    validateTransferScene(caseConf, validationOptions),
    validateCustomStateNodes(caseConf, validationOptions),
    validateGradeEffectNodes(caseConf, validationOptions),
    validateExposeNodes(caseConf, nodeInfo, validationOptions),
    validateCheckCounts(caseConf, validationOptions),
    validatePulseStrengthChecks(caseConf, validationOptions),
    validateGradingConflicts(caseConf, validationOptions),
    validateTriggeringActions(caseConf, nodeInfo, validationOptions),
    validateCustomMenuNodes(caseConf, nodeInfo),
  ];
  return mergeWith({}, ...validationResults, (objValue, srcValue) => {
    if (isArray(objValue)) {
      return objValue.concat(srcValue);
    }
    return undefined;
  });
}

export default validateCaseLogicDescription;
